export const CONSENT_SOURCES = ['form', 'whatsapp', 'web', 'manual'] as const;

export type ConsentSource = (typeof CONSENT_SOURCES)[number];

export const isConsentSource = (value: string): value is ConsentSource =>
  (CONSENT_SOURCES as readonly string[]).includes(value);

export type ConsentType = 'data_processing' | 'recording';

export interface ConsentTypeStatus {
  granted: boolean;
  occurredAt: string;
  source: string;
}

export interface ConsentStatus {
  dataProcessing: ConsentTypeStatus | null;
  recording: ConsentTypeStatus | null;
}

export interface RecordConsentBody {
  leadId: string;
  consentType: ConsentType;
  granted: boolean;
  source: ConsentSource;
  evidenceUrl?: string;
  occurredAt?: string;
  sourceMetadata?: Record<string, unknown>;
}

export interface SetMarketingConsentBody {
  granted: boolean;
  source: ConsentSource;
}
